const strings = require("../lang/fr_CA.json");

export const lang = (key, lang='fr') => {
    if (lang === 'fr' && strings[key]) {
        return strings[key];
    }
    return key;
};
